module.exports = __webpack_public_path__ + "img/kkmart-img.82e02e6b.png";